let stage = '';

export const initEnv = (stageValue: string) => {
  stage = stageValue;
};

export const cookieConfig = {
  // 区分正式环境和测试环境、本地部署环境、本地开发环境
  get TOKEN_PREFIX() {
    switch (stage) {
      case 'development':
        return 'DEV_';
      case 'pre':
        return 'PRE_';
      case 'local_deploy':
        return 'LOCAL_';
      case 'internet':
        return 'INTERNET_';
      case 'production':
      default: {
        return '';
      }
    }
  },
  // cookie domain
  get COOKIE_DOMAIN() {
    return ['pre', 'production'].includes(stage)
      ? window.location.hostname.endsWith('gptbase.ai')
        ? '.gptbase.ai'
        : '.gbase.ai'
      : '';
  },
};

// token 值 `toekn_type + access_token`
export const KEY_MYGPT_TOKEN = () => cookieConfig.TOKEN_PREFIX + 'MY_GPT_TOKEN';

// refrsh token 值
export const KEY_MYGPT_REFRESH_TOKEN = () => cookieConfig.TOKEN_PREFIX + 'KEY_MYGPT_REFRESH_TOKEN';

// token 过期时间
export const KEY_MYGPT_TOKEN_EXPIRESIN = () => cookieConfig.TOKEN_PREFIX + 'MY_GPT_TOKEN_EXPIRESIN';

// chat 对话历史
export const KEY_MYGPT_COMPLETIONS = 'MY_GPT_COMPLETIONS';

// 存储登录前的pathName
export const KEY_MYGPT_PATH_NAME = 'MY_GPT_PATH_NAME';

// 多语言
export const KEY_TRANSLATE_LANGUAGE = 'MY_GPT_LANGUAGE';

// 用户昵称
export const KEY_USER_NICKNAME = 'MY_GPT_USER_NICKNAME';

// 用户指纹
export const KEY_USER_FINGERPRINT = 'MY_GPT_USER_FINGERPRINT';

// Mixpanel Token
export const MIXPANEL_TOKEN = '1c7ce9876de96d036ad15d8c4e55c5b1';
export const COOKIE_KEY_MIXPANEL = `mp_${MIXPANEL_TOKEN}_mixpanel`;

// Widget Message Key
export const IFRAME_MESSAGE_OPEN = 'gptBaseWidgetOpened';
export const IFRAME_MESSAGE_CLOSE = 'gptBaseWidgetClose';

// Master Size
export const MASTER_SIZE = 'https://gbase.ai';

// Question Type
export const QUESTION_TYPE = {
  SIMPLE: 'simple',
  DETAIL: 'detail',
};

//AI STATUS
export const AI_STATUS = {
  INIT: 'init',
  READY: 'ready',
};

// checkout environment
export const PRODUCTION_STAGE_DEV = stage === 'pre';

// widget footerBrand default value
export const WIDGET_FOOTER_DEFAULT_TEXT = 'Powered by GBase';

// Language List
export const LANGUAGE_OPTIONS_LIST = {
  en: ' English',
  'zh-Hans': '简体中文',
  'zh-Hant': '繁體中文',
  ja: ' 日本語',
  ko: ' 한국어',
  es: ' Español',
  fr: ' Français',
  de: ' Deutsch',
  ru: ' Русский',
  pt: ' Português',
  it: ' Italiano',
  nl: ' Nederlands',
  pl: ' Polski',
  sv: ' Svenska',
  da: ' Dansk',
  no: ' Norsk',
  fi: ' Suomi',
  tr: ' Türkçe',
  ar: ' العربية',
  he: ' עברית',
  hi: ' हिन्दी',
  id: ' Bahasa Indonesia',
  ms: ' Bahasa Melayu',
  th: ' ไทย',
  vi: ' Tiếng Việt',
  el: ' Ελληνικά',
  hu: ' Magyar',
  cs: ' Čeština',
  sk: ' Slovenčina',
  uk: ' Українська',
  bg: ' Български',
  ro: ' Română',
  hr: ' Hrvatski',
  sr: ' Српски',
  sl: ' Slovenščina',
  et: ' Eesti',
  lv: ' Latviešu',
  lt: ' Lietuvių',
};
